import { Component, 
  OnInit, 
  ElementRef, 
  Input, 
  OnChanges,
  SimpleChange, SimpleChanges, Inject
} from '@angular/core';

import 'fabric';
import { ShapePosition} from './shapePosition';
import { ConfigurateurFacade, ConfigurateurModele, ConfigurateurPoignee, ConfigurateurAccessoire, ConfigurateurVitrage, RenderModele, RenderCanvas, ConfigurateurData, ConfigurateurEnseigne } from "app/model/configurateur";
import * as jsPDF from 'jspdf';
import { ToReverseHtmlPipe } from 'app/pipes/toHtmlContent.pipe';

import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx'
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

declare let fabric;

fabric.Image.fromURL = function(url, callback, imgOptions, crossOrigin) {
  var img = fabric.document.createElement('img');
  if (crossOrigin != null && url.indexOf('data:') != 0)
  {
    img.crossOrigin = crossOrigin;
  }
  else
  {
    img.crossOrigin = 'Anonymous';
  }

  /** @ignore */
  img.onload = function() {
    if (callback) {
      if (img) {
        console.log(img.src + " => cross: " + img.crossOrigin);
      }
      callback(new fabric.Image(img, imgOptions));
      
    }
    img = img.onload = null;
  };
  img.src = url;
};

@Component({
  selector: 'app-canvas',
  templateUrl: './canvas.component.html',
  styleUrls: ['./canvas.component.css']
})
export class CanvasComponent implements OnInit, OnChanges {
    
  @Input() shapePosition = new ShapePosition();
  @Input() renderCanvas = new RenderCanvas();
  @Input() Data:ConfigurateurData;
  
  information:string;
  informationModele:string = 'aucun modèle';
  informationVitrage:string = 'aucun vitrage';
  informationPoignee:string = 'aucune poignée';
  informationAccessoire:string = 'aucun accessoire';
  showCustomPanel:boolean = false;
  canMoveModele:boolean = false;
  canMovePoignee:boolean = false;
  canMoveAccessoire:boolean = false;
  positionModeleX:number=0; positionModeleY:number=0;
  scaleModeleX:number=1; scaleModeleY:number=1;
  positionPoigneeX:number=0; positionPoigneeY:number=0;
  positionAccessoireX:number=0; positionAccessoireY:number=0;

  public canvas;

  constructor(private element: ElementRef, ) { }

  switchToModification(celement:string, cstate:boolean)
  {
    let oGroup = this.getCanvasItemById(this.canvas, 'group');
    
    if (celement == "modele") {
      this.canMoveModele = cstate;
    }
    else if (celement == "poignee") {
      this.canMovePoignee = cstate;
      if (cstate) {
        
        let sthis = this;
         
        fabric.Image.fromURL(this.renderCanvas.poignee.img, function(oImg) {
            
            var l = sthis.positionModeleX + sthis.positionPoigneeX;
            var t = sthis.positionModeleY + sthis.positionPoigneeY;
            oImg.set({'id':'clonePoignee', 'alt' : sthis.renderCanvas.poignee.code, 'left':l, 'top':t,  'hasRotatingPoint':false, 'hasControls':false, 'selectable':false , 'crossOrigin': 'Anonymous'});
  
            if (sthis.canvas != null) {
              sthis.canvas.add(oImg);
              sthis.canvas.bringToFront(oImg);
              sthis.canvas.setActiveObject(oImg);
              sthis.canvas.renderAll();   
            }
          }); 

      }
      else {
        let clonePoignee = this.getCanvasItemById(this.canvas, 'clonePoignee');
        this.canvas.remove(clonePoignee);
        this.canvas.renderAll();   
      }
      oGroup.selectable = (! this.canMoveAccessoire && ! this.canMovePoignee);
    }
    else if (celement == "accessoire") {
      this.canMoveAccessoire = cstate;
      if (cstate) {
        let sthis = this;
        
        fabric.Image.fromURL(this.renderCanvas.accessoire.img, function(oImg) {
          
          var l = sthis.positionModeleX + sthis.positionAccessoireX;
          var t = sthis.positionModeleY + sthis.positionAccessoireY;
          oImg.set({'id':'cloneAccessoire', 'alt' : sthis.renderCanvas.accessoire.code, 'left':l, 'top':t,  'hasRotatingPoint':false, 'hasControls':false, 'selectable': false, 'crossOrigin': 'Anonymous'});

          if (sthis.canvas != null) {
            sthis.canvas.add(oImg);
            sthis.canvas.bringToFront(oImg);
            sthis.canvas.setActiveObject(oImg);
            sthis.canvas.renderAll();   
          }
        });
      }
      else {
        let cloneAccessoire = this.getCanvasItemById(this.canvas, 'cloneAccessoire');
        this.canvas.remove(cloneAccessoire);
        this.canvas.renderAll();   
      }
      oGroup.selectable = (! this.canMoveAccessoire && ! this.canMovePoignee);
    }

    this.displayCanvas(this);
  }


  ngOnInit() {

    this.canvas = new fabric.Canvas('canvas', {
      width: this.element.nativeElement.parentElement.clientWidth,
      height: this.element.nativeElement.parentElement.clientHeight
    });

    this.canvas.add(new fabric.Group([], { 'id': 'group' }));
    
    let sthis = this;
    this.canvas.on('mouse:up', function(options){
      if (options.target != null && sthis.renderCanvas != null) {

        let oGroup = sthis.getCanvasItemById(sthis.canvas, 'group');

          if(options.target.id == 'group') {
          
              if (sthis.renderCanvas.poignee != null && oGroup != null) {
                sthis.positionModeleX = options.target.left;
                sthis.positionModeleY = options.target.top;
                sthis.scaleModeleX = options.target.scaleX;
                sthis.scaleModeleY = options.target.scaleY;
                sthis.renderCanvas.facade.x = options.target.left;
                sthis.renderCanvas.facade.y = options.target.top;
                
                console.log('objet modele:X = ' + options.target.left  + " (scale: "  + options.target.scaleX + ", largeur: " + Math.round(options.target.width * options.target.scaleX) + ")");
                console.log('objet modele:Y = ' + options.target.top  + " (scale: "  + options.target.scaleX + ", hauteur: " + Math.round(options.target.height * options.target.scaleY) + ")");
                sthis.informationModele = "objet modele: " +  sthis.renderCanvas.modele.code + " => (X: " + options.target.left + ", Y: " + options.target.top + ", largeur: " + Math.round(options.target.width * options.target.scaleX) + ", hauteur: " + Math.round(options.target.height * options.target.scaleY) + ")";
              }
          }

          if(options.target.id == 'clonePoignee') {

              let oPoignee = sthis.getCanvasItemById(sthis.canvas, 'clonePoignee');
              if (sthis.renderCanvas.poignee != null && oPoignee != null) {
                  sthis.positionPoigneeX = oPoignee.left;
                  sthis.positionPoigneeY = oPoignee.top;
                  
                  let px = (oPoignee.left - oGroup.left);
                  let py = (oPoignee.top - oGroup.top);

                  console.log('objet poignee:X = ' + px);
                  console.log('objet poignee:Y = ' + py);
                  sthis.informationPoignee = "objet poignee : " + sthis.renderCanvas.poignee.code + " => (X: " + px + ", Y: " + py + ")";
              }
          }

          if(options.target.id == 'cloneAccessoire') {
  
            let oAccessoire = sthis.getCanvasItemById(sthis.canvas, 'cloneAccessoire');
            if (sthis.renderCanvas.accessoire != null && oAccessoire != null) {
                sthis.positionAccessoireX = oAccessoire.left;
                sthis.positionAccessoireY = oAccessoire.top;
                
                let ax = (oAccessoire.left - oGroup.left);
                let ay = (oAccessoire.top - oGroup.top);

                console.log('objet accessoire:X = ' + ax);
                console.log('objet accessoire:Y = ' + ay);
                sthis.informationAccessoire = "objet accessoire: " + sthis.renderCanvas.accessoire.code + " => (X: " + ax + ", Y: " + ay + ")";
            }
          }
        }


    });

    this.canvas.on('mouse:down', function(options){
      if (options.target != null) {

        if (sthis.renderCanvas != null) {
          if (sthis.renderCanvas.modele != null && options.target.id == 'modele') {

          
          let oVitrage = sthis.getCanvasItemById(sthis.canvas, 'vitrage');
          if (oVitrage != null) {
            sthis.canvas.remove(oVitrage);
          }
          let oPoignee = sthis.getCanvasItemById(sthis.canvas, 'poignee');
          if (oPoignee != null) {
            sthis.canvas.remove(oPoignee);
          }
          let oAccessoire = sthis.getCanvasItemById(sthis.canvas, 'accessoire');
          if (oAccessoire != null) {
            sthis.canvas.remove(oAccessoire);
          }
          }
          
        }
        
      }

    });

  }

getCanvasItemById(c:any, id:string) {
    var object = null;
    if(c != null) {
      var objects = c.getObjects();
      for (var i = 0, len = objects.length; i < len; i++) {
          if (objects[i].id&& objects[i].id=== id) {
              object = objects[i];
              break;
          }
      }
    }
    return object;
};

ngOnChanges(changes: {[propKey:string] : SimpleChange}){ // {[propKey:string] : SimpleChange} or SimpleChanges

    //var group2 = new fabric.Group([ circle1, circle2, circle3 ], { left: 200, top: 200 });
    let sthis = this;

    this.displayCanvas(sthis);

    if (this.canvas != null) {
      let oGroup = sthis.getCanvasItemById(this.canvas, 'group');
      this.displayGroupInOrder(oGroup);
    }

  }

    resizeCanvas(width:number, height:number) {
      if (this.canvas != null) {

        if (this.canvas.backgroundImage != null) {
          this.canvas.backgroundImage.scaleToWidth(width);
          this.canvas.backgroundImage.scaleToHeight(height);
        }
        
        this.canvas.setDimensions({width: width, height: height});
        this.canvas.renderAll();
      }
    }

  displayCanvas(sthis: CanvasComponent) {

    let oGroup = this.getCanvasItemById(this.canvas, 'group');
    
     if (this.renderCanvas != null && this.renderCanvas.facade != null && this.canvas != null) {
    
        oGroup.selectable = this.renderCanvas.facade.isCustom;
        oGroup.hasControls = this.renderCanvas.facade.isCustom;
        oGroup.hasRotatingPoint = this.renderCanvas.facade.isCustom;
        oGroup.evented = this.renderCanvas.facade.isCustom;

        if(this.renderCanvas.facade.isCustom) {
          this.information = "Facade importée, vous pouvez déplacer la porte et la resizer pour la mettre dans votre facade !";
          //this.showCustomPanel = true;
        }
        else {
          this.information = "";
          //this.showCustomPanel = false;
          this.scaleModeleX = 1;
          this.scaleModeleY = 1;
          
        }

        fabric.Image.fromURL(this.renderCanvas.facade.img, function(oImg) {
       
          let locScaleX = (sthis.renderCanvas.facade.isCustom ? 880 / oImg.width : 1);
          let locScaleY = (sthis.renderCanvas.facade.isCustom ? 660 / oImg.height : 1);
          
          sthis.canvas.setBackgroundImage(sthis.renderCanvas.facade.img, sthis.canvas.renderAll.bind(sthis.canvas), {
              backgroundImageOpacity: 0.5,
              backgroundImageStretch: false,
              scaleX : locScaleX,
              scaleY : locScaleY,
              crossOrigin: 'Anonymous'
          });
        });
       
       
    }

    if (this.renderCanvas != null && this.renderCanvas.modele != null && this.canvas != null) {

      
      // get element id modele
      let imgModele = this.getCanvasItemById(oGroup, 'modele');
      if (imgModele != null && oGroup != null) {
        oGroup.remove(imgModele);
      }

      this.positionModeleX = (this.positionModeleX > 0 && this.renderCanvas.facade.isCustom ? this.positionModeleX : (this.renderCanvas.facade.x != undefined ? this.renderCanvas.facade.x: 0));
      this.positionModeleY = (this.positionModeleY > 0 && this.renderCanvas.facade.isCustom ? this.positionModeleY : (this.renderCanvas.facade.y != undefined ? this.renderCanvas.facade.y: 0));
      
      fabric.Image.fromURL(this.renderCanvas.modele.img, function(oImg) {
          
          var l = sthis.positionModeleX;
          var t = sthis.positionModeleY;
          oImg.set({'id':'modele', 'alt' : sthis.renderCanvas.modele.code , 'left':l, 'top':t,  'hasRotatingPoint':false, 'selectable':false, 'scaleX': sthis.scaleModeleX , 'scaleY': sthis.scaleModeleY, 'crossOrigin': 'Anonymous'});

          sthis.informationModele = "objet modele: " +  sthis.renderCanvas.modele.code + " => (X: " + l + ", Y: " + t + ", largeur: " + oImg.width + ", hauteur: " + oImg.height + ", scale X: " + sthis.scaleModeleX + ", scale Y: " + sthis.scaleModeleY + ")";
          
          if (oGroup != null) {
            oGroup.addWithUpdate(oImg);
            sthis.displayGroupInOrder(oGroup);
          }
          
        });

    } 
    else if (this.renderCanvas != null && this.renderCanvas.modele == null) {
      let imgModele = this.getCanvasItemById(oGroup, 'modele');
      if (imgModele != null) {
            this.canvas.remove(imgModele);

            this.informationModele = 'aucun modèle';
        }
    } 

    // rendu du vitrage
    if (this.renderCanvas != null && this.renderCanvas.vitrage != null && this.canvas != null) {

      // get element id modele
      let imgVitrage = this.getCanvasItemById(oGroup, 'vitrage');
      if (imgVitrage != null) {
        oGroup.remove(imgVitrage);
      }

      this.positionModeleX = (this.positionModeleX > 0 && this.renderCanvas.facade.isCustom ? this.positionModeleX : (this.renderCanvas.facade.x != undefined ? this.renderCanvas.facade.x: 0));
      this.positionModeleY = (this.positionModeleY > 0 && this.renderCanvas.facade.isCustom ? this.positionModeleY : (this.renderCanvas.facade.y != undefined ? this.renderCanvas.facade.y: 0));

      let thisVitrage = this.renderCanvas.vitrage;
      fabric.Image.fromURL(this.renderCanvas.vitrage.img, function(oImg) {
          
          var l = sthis.positionModeleX + (thisVitrage.x != undefined ? thisVitrage.x: 0);
          var t = sthis.positionModeleY + (thisVitrage.y != undefined ? thisVitrage.y: 0);
          oImg.set({'id':'vitrage', 'alt' : sthis.renderCanvas.vitrage.code, 'left':l, 'top':t,  'hasRotatingPoint':false, 'hasControls':false, 'selectable':false, 'scaleX': sthis.scaleModeleX , 'scaleY': sthis.scaleModeleY, 'crossOrigin': 'Anonymous'});

          sthis.informationVitrage = 'objet vitrage: ' + sthis.renderCanvas.vitrage.code;

          if (oGroup != null) {
            oGroup.addWithUpdate(oImg);
            sthis.displayGroupInOrder(oGroup);
          }
        });

    }
    else if (this.renderCanvas != null && this.renderCanvas.vitrage == null) {
      let imgVitrage = this.getCanvasItemById(oGroup, 'vitrage');
            if (imgVitrage != null) {
              oGroup.remove(imgVitrage);

              this.informationVitrage = 'aucun vitrage';
            }
    }
    
    if (this.renderCanvas != null && this.renderCanvas.poignee != null && this.canvas != null) {

      // get element id modele
      let imgPoignee = this.getCanvasItemById(oGroup, 'poignee');
      if (imgPoignee != null) {
        oGroup.remove(imgPoignee);
      }

      this.positionModeleX = (this.positionModeleX > 0 && this.renderCanvas.facade.isCustom ? this.positionModeleX : (this.renderCanvas.facade.x != undefined ? this.renderCanvas.facade.x: 0));
      this.positionModeleY = (this.positionModeleY > 0 && this.renderCanvas.facade.isCustom ? this.positionModeleY : (this.renderCanvas.facade.y != undefined ? this.renderCanvas.facade.y: 0));

      this.positionPoigneeX = (this.positionPoigneeX > 0 && this.renderCanvas.facade.isCustom ? this.positionPoigneeX : (this.renderCanvas.poignee.x != undefined ? this.renderCanvas.poignee.x: 0));
      this.positionPoigneeY = (this.positionPoigneeY > 0 && this.renderCanvas.facade.isCustom ? this.positionPoigneeY : (this.renderCanvas.poignee.y != undefined ? this.renderCanvas.poignee.y: 0));
       
      fabric.Image.fromURL(this.renderCanvas.poignee.img, function(oImg) {
          
          var l = sthis.positionModeleX + sthis.positionPoigneeX * sthis.scaleModeleX;
          var t = sthis.positionModeleY + sthis.positionPoigneeY * sthis.scaleModeleY;
          oImg.set({'id':'poignee', 'alt' : sthis.renderCanvas.poignee.code, 'left':l, 'top':t,  'hasRotatingPoint':false, 'hasControls':false, 'selectable':false, 'scaleX': sthis.scaleModeleX , 'scaleY': sthis.scaleModeleY, 'crossOrigin': 'Anonymous'});

          sthis.informationPoignee = "objet poignee : " + sthis.renderCanvas.poignee.code + " => (X: " + (l - sthis.positionModeleX)+ ", Y: " + (t - sthis.positionModeleY) + ")";

          if (oGroup != null) {
            oGroup.addWithUpdate(oImg);
            sthis.displayGroupInOrder(oGroup);
          }
        });

    }
    else if (this.renderCanvas != null && this.renderCanvas.poignee == null) {
      let imgPoignee = this.getCanvasItemById(oGroup, 'poignee');
            if (imgPoignee != null) {
              oGroup.remove(imgPoignee);

              this.informationPoignee = 'aucune poignée';
            }
    }

    if (this.renderCanvas != null && this.renderCanvas.accessoire != null && this.canvas != null) {

      // get element id modele
      let imgAccessoire = this.getCanvasItemById(oGroup, 'accessoire');
      if (imgAccessoire != null) {
        oGroup.remove(imgAccessoire);
      }

      this.positionModeleX = (this.positionModeleX > 0 && this.renderCanvas.facade.isCustom ? this.positionModeleX : (this.renderCanvas.facade.x != undefined ? this.renderCanvas.facade.x: 0));
      this.positionModeleY = (this.positionModeleY > 0 && this.renderCanvas.facade.isCustom ? this.positionModeleY : (this.renderCanvas.facade.y != undefined ? this.renderCanvas.facade.y: 0));

      this.positionAccessoireX = (this.positionAccessoireX > 0 && this.renderCanvas.facade.isCustom ? this.positionAccessoireX : (this.renderCanvas.accessoire.x != undefined ? this.renderCanvas.accessoire.x: 0));
      this.positionAccessoireY = (this.positionAccessoireY > 0 && this.renderCanvas.facade.isCustom ? this.positionAccessoireY : (this.renderCanvas.accessoire.y != undefined ? this.renderCanvas.accessoire.y: 0));

      fabric.Image.fromURL(this.renderCanvas.accessoire.img, function(oImg) {
          
          var l = sthis.positionModeleX + sthis.positionAccessoireX * sthis.scaleModeleX;
          var t = sthis.positionModeleY + sthis.positionAccessoireY * sthis.scaleModeleY;
          oImg.set({'id':'accessoire', 'alt' : sthis.renderCanvas.accessoire.code, 'left':l, 'top':t,  'hasRotatingPoint':false, 'hasControls':false, 'selectable': false, 'scaleX': sthis.scaleModeleX , 'scaleY': sthis.scaleModeleY, 'crossOrigin': 'Anonymous'});

          sthis.informationAccessoire = "objet accessoire : " + sthis.renderCanvas.accessoire.code + " => (X: " + (l - sthis.positionModeleX) + ", Y: " + (t - sthis.positionModeleY) + ")";
          
          if (oGroup != null) {
            oGroup.addWithUpdate(oImg);
            sthis.displayGroupInOrder(oGroup);
          }
        });

    }
    else if (this.renderCanvas != null && this.renderCanvas.accessoire == null) {
      let imgAccessoire = this.getCanvasItemById(oGroup, "accessoire");
      if (imgAccessoire != null) {
        oGroup.remove(imgAccessoire);

        this.informationAccessoire = 'aucun accessoire';
      }
    }

  }

  logInformation(parentElement:any, titre:string = "Group objs :", resetText:boolean = true){
    // log information
    if (resetText) {
      this.information = titre;
    }
    else {
      this.information += titre;
    }
    
    if (parentElement != null)
    {
    let objsFromGroup = parentElement.getObjects();
    this.information += " (" + objsFromGroup.length + ")";
    for (var i = 0, len = objsFromGroup.length; i < len; i++) {
      let objectFromGroup = objsFromGroup[i];
      this.information += " / " + objectFromGroup.id; // + " (" + objectFromGroup.alt + ")" ;
      
      }
    }
  }

  displayGroupInOrder(parentElement:any, renderAll:boolean = true) {

    if (parentElement != null) {

      let imgVitrage = this.getCanvasItemById(parentElement, 'vitrage');
      let imgModele = this.getCanvasItemById(parentElement, 'modele');
      let imgAccessoire = this.getCanvasItemById(parentElement, 'accessoire');
      let imgPoignee = this.getCanvasItemById(parentElement, 'poignee');
  
      let countElement = 0;

      if (imgVitrage != null) {
        imgVitrage.moveTo(countElement);
        countElement++;
      }

      if (imgModele != null) {
        imgModele.moveTo(countElement);
        countElement++;
      }
  
      if (imgPoignee != null) {
        imgPoignee.moveTo(countElement);
        countElement++;
      }
  
      if (imgAccessoire != null) {
        imgAccessoire.moveTo(countElement);
        countElement++;
      }


      if(renderAll && this.canvas != null) {
        this.canvas.renderAll();
      }

      this.logInformation(parentElement, "Ordre des éléments: ");
    }
   
  }


  printDevis(item:RenderCanvas) {
    console.log('printDevis : ' + (item != null ? item.modele : 'not init'));
    let sthis = this;
    if (this.Data.enseigneActive != null) {

      fabric.Image.fromURL(this.Data.enseigneActive.logo, function(oImg) {
        
        sthis.downloadPdf(sthis.Data.enseigneActive, oImg);
  
      }); 

    }

  }
  
  downloadPdf(enseigne:ConfigurateurEnseigne, fabricImgLogo) {
    
      var doc = new jsPDF(); // new jsPDF("p","mm","a4");
      
      
      let textModele = ToReverseHtmlPipe.reverseHtmlEntities(this.renderCanvas.modele.name);
      let textVitrage = (this.renderCanvas.vitrage != null ? ToReverseHtmlPipe.reverseHtmlEntities(this.renderCanvas.vitrage.name) : 'Non');
      let textPoignee = ToReverseHtmlPipe.reverseHtmlEntities(this.renderCanvas.poignee.name);
      let textAccessoire = (this.renderCanvas.accessoire != null ? ToReverseHtmlPipe.reverseHtmlEntities(this.renderCanvas.accessoire.name) : 'Non');

      let imgLogo = new Image();
      
      imgLogo.setAttribute('crossOrigin', 'Anonymous'); // works for me
      imgLogo.src=fabricImgLogo.toDataURL({format: 'png'});
      
      doc.addImage(imgLogo, "PNG", 0, 0); 

      //var lMargin=60; //left margin in mm
      //var rMargin=40; //right margin in mm
      //var pdfInMM=210;  // width of A4 in mm
      // var paragraph="Merci d’avoir choisi " + enseigne.name + " pour pour configurer votre future porte d’entrée. Vous trouverez ci-dessous le récapitulatif de votre projet. Il ne vous reste plus qu’à l’imprimer et vous rendre dans votre magasin le plus proche.";
      // var lines =doc.splitTextToSize(paragraph, (pdfInMM-lMargin-rMargin));
      // doc.text(lMargin,20,lines);

      let colorPrimaryRGB:number[] = this.getColor(enseigne.pdfSetting.colorPrimary);
      let colorSecondaryRGB:number[] = this.getColor(enseigne.pdfSetting.colorSecond);
      let colorBackgroundTablePrimaryRGB:number[] = this.getColor(enseigne.pdfSetting.colorBackgroundTablePrimary);
      let colorBackgroundTableSecondRGB:number[] = this.getColor(enseigne.pdfSetting.colorBackgroundTableSecond);

      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.setTextColor(colorSecondaryRGB[0],colorSecondaryRGB[1],colorSecondaryRGB[2]);
      doc.text(60, 60, enseigne.pdfSetting.descriptifTitle);
      doc.text(140, 60, enseigne.pdfSetting.itemTitle);
      doc.setTextColor(colorPrimaryRGB[0],colorPrimaryRGB[1],colorPrimaryRGB[2]);
      doc.setFontType("normal");
      
      // description
      let titles: string[] =[ 'Composition', 'Modèle', 'Design', 'Matériau', 'Couleur', 'Vitrage', 'Poignée', 'Accessoires' ];
      let values: string[] =[ this.renderCanvas.modele.nameGroupe, this.renderCanvas.modele.nameModele, this.renderCanvas.modele.nameDesign, this.renderCanvas.modele.nameMateriau, this.renderCanvas.modele.nameCouleur, textVitrage, textPoignee, textAccessoire ];
      for(let indexDescription=0;indexDescription<=7;indexDescription++) {

        if (indexDescription % 2 == 0) {
          doc.setFillColor(colorBackgroundTablePrimaryRGB[0], colorBackgroundTablePrimaryRGB[1],colorBackgroundTablePrimaryRGB[2]);
        }
        else {
          doc.setFillColor(colorBackgroundTableSecondRGB[0], colorBackgroundTableSecondRGB[1],colorBackgroundTableSecondRGB[2]);
        }
        
        doc.rect(20, 65 + 10*indexDescription , 110, 10, "F");

        doc.setTextColor(colorPrimaryRGB[0],colorPrimaryRGB[1],colorPrimaryRGB[2]);
        doc.text(30, 65 + 10*indexDescription + 6, titles[indexDescription]);

        doc.setTextColor(colorSecondaryRGB[0],colorSecondaryRGB[1],colorSecondaryRGB[2]);
        doc.text(80, 65 + 10*indexDescription + 6, values[indexDescription]);
      }
      
      // porte
      doc.setFillColor(colorBackgroundTablePrimaryRGB[0], colorBackgroundTablePrimaryRGB[1],colorBackgroundTablePrimaryRGB[2]);
      doc.rect(140, 65, 50, 80, "F");
      
      let imgPorte = new Image();
      let oGroup = this.getCanvasItemById(this.canvas, 'group');
      
      imgPorte.setAttribute('crossOrigin', 'Anonymous'); // works for me
      imgPorte.src=oGroup.toDataURL({format: 'jpg'});
      
      doc.addImage(imgPorte, "JPEG", 150, 70, 30, 68); 

      // PROBLEME DE CORS cross domain : crossOrigin
      let img = new Image();

      img.setAttribute('crossOrigin', 'Anonymous'); // works for me
      img.src=this.canvas.toDataURL({format: 'jpg'});
      
      doc.addImage(img, "JPEG", 30, 155, 150, 114); 

      // footer
      // porte
      doc.setFontSize(10);
      doc.setFillColor(colorBackgroundTablePrimaryRGB[0], colorBackgroundTablePrimaryRGB[1],colorBackgroundTablePrimaryRGB[2]);
      doc.rect(0, 275, 210, 25, "F");
      doc.setTextColor(colorSecondaryRGB[0],colorSecondaryRGB[1],colorSecondaryRGB[2]);
      doc.text(90, 285 , enseigne.pdfSetting.bottomTitle);
      doc.setTextColor(colorPrimaryRGB[0],colorPrimaryRGB[1],colorPrimaryRGB[2]);
      //doc.text(80, 285 , enseigne.site + ' >');
      doc.textWithLink(enseigne.site + ' >', 80, 290, {url: enseigne.site});
      

      //Ajout ligne du footer
      doc.setTextColor(colorPrimaryRGB[0],colorPrimaryRGB[1],colorPrimaryRGB[2]);
      doc.setFontType("normal");
      doc.setFontSize(7);
      doc.text(30, 295, "Photos et caractéristiques non contractuelles. Merci de vérifier la faisabilité auprès de votre revendeur le plus proche.");

      // Save the PDF
      doc.save(enseigne.pdfSetting.filename);
  }

  getColor(color:string): number[] {

    let rgb : number[];

    if (color !== undefined && color !== null && color.length > 0) {
        rgb = color.split(',').map(a => {return parseInt(a)});
    }

    return rgb;
  }

    downloadPdfOrigine(enseigne, fabricImgLogo) {
      
      var doc = new jsPDF(); // new jsPDF("p","mm","a4");
      
      
      let textModele = ToReverseHtmlPipe.reverseHtmlEntities(this.renderCanvas.modele.name);
      let textVitrage = (this.renderCanvas.vitrage != null ? ToReverseHtmlPipe.reverseHtmlEntities(this.renderCanvas.vitrage.name) : 'Non');
      let textPoignee = ToReverseHtmlPipe.reverseHtmlEntities(this.renderCanvas.poignee.name);
      let textAccessoire = (this.renderCanvas.accessoire != null ? ToReverseHtmlPipe.reverseHtmlEntities(this.renderCanvas.accessoire.name) : 'Non');

      let imgLogo = new Image();
      
      imgLogo.setAttribute('crossOrigin', 'Anonymous'); // works for me
      imgLogo.src=fabricImgLogo.toDataURL({format: 'png'});
      
      doc.addImage(imgLogo, "PNG", 0, 0); 

      //var lMargin=60; //left margin in mm
      //var rMargin=40; //right margin in mm
      //var pdfInMM=210;  // width of A4 in mm
      // var paragraph="Merci d’avoir choisi " + enseigne.name + " pour pour configurer votre future porte d’entrée. Vous trouverez ci-dessous le récapitulatif de votre projet. Il ne vous reste plus qu’à l’imprimer et vous rendre dans votre magasin le plus proche.";
      // var lines =doc.splitTextToSize(paragraph, (pdfInMM-lMargin-rMargin));
      // doc.text(lMargin,20,lines);

      doc.setFontSize(12);
      doc.setFontType("bold");
      doc.setTextColor(169,0,56);
      doc.text(60, 60, 'DESCRIPTIF');
      doc.text(140, 60, 'LA PORTE DE VOS RÊVES');
      doc.setTextColor(0,0,0);
      doc.setFontType("normal");
      
      // description
      let titles: string[] =[ 'Composition', 'Modèle', 'Design', 'Matériau', 'Couleur', 'Vitrage', 'Poignée', 'Accessoires' ];
      let values: string[] =[ this.renderCanvas.modele.nameGroupe, this.renderCanvas.modele.nameModele, this.renderCanvas.modele.nameDesign, this.renderCanvas.modele.nameMateriau, this.renderCanvas.modele.nameCouleur, textVitrage, textPoignee, textAccessoire ];
      for(let indexDescription=0;indexDescription<=7;indexDescription++) {

        if (indexDescription % 2 == 0) {
          doc.setFillColor(240, 237,235);
        }
        else {
          doc.setFillColor(255, 254, 253);
        }
        
        doc.rect(20, 65 + 10*indexDescription , 110, 10, "F");

        doc.setTextColor(0, 0, 0);
        doc.text(30, 65 + 10*indexDescription + 6, titles[indexDescription]);

        doc.setTextColor(169,0,56);
        doc.text(80, 65 + 10*indexDescription + 6, values[indexDescription]);
      }
      
      // porte
      doc.setFillColor(240, 237,235);
      doc.rect(140, 65, 50, 80, "F");
      
      let imgPorte = new Image();
      let oGroup = this.getCanvasItemById(this.canvas, 'group');
      
      imgPorte.setAttribute('crossOrigin', 'Anonymous'); // works for me
      imgPorte.src=oGroup.toDataURL({format: 'jpg'});
      
      doc.addImage(imgPorte, "JPEG", 150, 70, 30, 68); 

      // PROBLEME DE CORS cross domain : crossOrigin
      let img = new Image();

      img.setAttribute('crossOrigin', 'Anonymous'); // works for me
      img.src=this.canvas.toDataURL({format: 'jpg'});
      
      doc.addImage(img, "JPEG", 30, 155, 150, 114); 

      // footer
      // porte
      doc.setFontSize(10);
      doc.setFillColor(240, 237,235);
      doc.rect(0, 275, 210, 25, "F");
      doc.setTextColor(169,0,56);
      doc.text(90, 285 , enseigne.pdfSetting.bottomTitle);
      doc.setTextColor(0,0,0);
      //doc.text(80, 285 , enseigne.site + ' >');
      doc.textWithLink(enseigne.site + ' >', 80, 290, {url: enseigne.site});
      
      // Save the PDF
      doc.save(enseigne.pdfSetting.filename);
  }
}


// WEBPACK FOOTER //
// ./src/app/creator/canvas/canvas.component.ts